import * as React from 'react';
import { Checkbox, UIText2 } from '@cian/ui-kit';

import * as styles from './PublicationFromPackageCheckboxDesktop.css';
import { NBSP } from '../../../../../../../../constants/symbols';

export interface IPublicationFromPackageCheckboxDesktopProps {
  label: string;
  checked: boolean;
  disabled: boolean;

  handleChange(): void;
}

export const PublicationFromPackageCheckboxDesktop = ({
  label,
  checked,
  disabled,
  handleChange,
}: IPublicationFromPackageCheckboxDesktopProps) => {
  return (
    <div className={styles.wrapper}>
      <Checkbox
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        data-testid="PublicationFromPackageCheckbox"
      />

      <div className={styles.label} onClick={handleChange}>
        <UIText2 display="inline-block">Из пакета</UIText2>

        {Boolean(label) && (
          <>
            {NBSP}
            <UIText2 color="gray60_100" display="inline-block">
              {label}
            </UIText2>
          </>
        )}
      </div>
    </div>
  );
};
